export const getQvctSurveys = (state) => state.qvctSurveys
export const getQvctSurveyStats = (state) => (id) => state.qvctSurveyStats[id] || {}
export const getQvctSurveyOpinion = (state) => (id) => state.qvctSurveyOpinion[id] || {}
export const getQvctSurvey = (state) => (id) => state.qvctSurveys.find(x => x.id === id)
export const loadQuestions = (state) => (id) => state.qvctSurveyQuestions[id] || []
export const getQvctServeysCategoriesWithoutChildren = (state) => state.qvctSurveysCategoriesWithoutChildren
export const getQvctServeysRootCategories = (state) => state.qvctSurveysRootCategories
export const getQvctServeysAnswersType = (state) => state.qvctSurveysAnswersType
export const getQvctSurveyForResponse = (state) => state.qvctSurveyForResponse

export const loadQvctSurveyResponses = (state) => (id) => state.qvctSurveyResponses[id] || []

export const getQvctSurveyStatus = (state) => state.qvctSurveyStatus
